import { render, staticRenderFns } from "./TaxConfigurationGroupTaxReformForm.vue?vue&type=template&id=683e97e6&"
import script from "./TaxConfigurationGroupTaxReformForm.vue?vue&type=script&lang=js&"
export * from "./TaxConfigurationGroupTaxReformForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/echope/echope-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('683e97e6')) {
      api.createRecord('683e97e6', component.options)
    } else {
      api.reload('683e97e6', component.options)
    }
    module.hot.accept("./TaxConfigurationGroupTaxReformForm.vue?vue&type=template&id=683e97e6&", function () {
      api.rerender('683e97e6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/invoice/parameters/components/TaxConfigurationGroupTaxReformForm.vue"
export default component.exports